export const errorTranslations = {
  // General errors
  AnErrorOccurred: 'An error occurred!',
  ErrorOccurred: 'The following error occurred.',
  PleaseTryAgain: 'Please try again.',

  // File upload errors
  FileUploadFailed: 'File upload failed!',
  FailedToUploadArticle: 'Failed to upload article',
  UploadError: 'File upload failed',
  FileTooLarge: 'File too large. Max 5MB size limit',
  FileSizeError:
    'The file size exceeds 5 MB. Please re-upload within the supported size.',
  LongFileError:
    'The file is too long. Please re-upload within the allowed length.',
  ImageFileUploadError: 'Image files cannot be uploaded.',
  InvalidFileFormat: 'Supported file types: pdf, doc, docx, txt, ppt, pptx',
  FileSizeLimitError: 'Maximum file size is 15MB per file',
  FileCountLimitError: 'The maximum number of files that can be saved is 20',
  YouCanOnlyUploadTenFiles: 'You can only upload 10 files!',

  // Deletion errors and confirmations
  DeletionFailed: 'Deletion failed.',
  FailedToDeleteBookmark: 'Failed to delete bookmark.',
  DeleteDocumentError: 'Failed to delete document',
  ItHasBeenDeleted: 'It has been deleted.',
  BookmarkHasBeenDeleted: 'Bookmark has been deleted',
  AreYouSureYouWantToDeleteThisFile:
    'Are you sure you want to delete this file?',
  WhenDeletedFileRemoveeFromTheProject:
    'When deleted, the file is removed from the project.',
  DeleteFile: 'Delete',

  // Authorization errors
  UnauthorizedAccess: 'Unauthorized Access',

  // Query validation errors
  QueryIsEmpty: 'Query is empty!',
  PleaseSelectAtLeastOneSource: 'Please select at least one source!',
  pleaseSelectSource: 'Please select at least one source',

  // URL validation errors
  PleaseEnterAValidURL: 'Please enter a valid URL',
  WebsiteLinkError:
    'The content of this URL cannot be summarized. Please enter a different URL or try again.',

  // Content validation errors
  PleaseEnterTheTextYouWantToTranslate:
    'Please enter the text you want to translate',
  PleaseEnterTextToSummarize: 'Please enter text to summarize',

  // Date validation errors
  PleaseEnterADate: 'Please enter a date',
  PleaseUseYYYYMMDDFormat: 'Please use YYYY/MM/DD format',

  // No results found
  NoResultsFound: 'No results found',
  NoSearchResultsFound: 'No search results found',
  NoArticlesFoundForTheSelectedFilters:
    'No articles found for the selected filters.',

  // Content availability errors
  NoBookmarksAvailable: 'No bookmarks available!',
  NoArticlesAvailable: 'No articles available!',
  NoWorkspacesFound: 'No workspaces found',
  NoProjectsFound: 'No projects found',
  NoDocuments: 'Please upload internal documents first',
  NofilesUploadsYet: 'No files uploaded yet',

  // Limit errors
  MaxWorkspaceReached: 'The current maximum number of workspaces is 2',

  // Preview and display errors
  FilePreviewNotAvailable: 'File preview not available',
  ImageLoadError: 'Image load error',
  ErrorOccured: 'An error occurred',

  // Update errors
  FailedToUpdateINDDraft: 'Failed to update draft',
  FailedToFetchINDDraft: 'Failed to fetch draft',

  // Generation errors
  InvalidCSRINDFileFormat: 'Supported file types: pdf, doc, docx, rtf',
  GenerationError: 'Generation Error',
  ThereWasAnErrorGeneratingTheContent:
    'There was an issue processing the prompt. Please try again.',
  Retry: 'Retry',
  Retrying: 'Retrying...',

  // Error Boundary
  AccessDenied: 'Access Denied',
  AccessDeniedSubtitle: 'You do not have permission to access this resource',
  PageNotFound: 'Page Not Found',
  PageNotFoundSubtitle: 'The page you are looking for does not exist',
  InternalServerError: 'Internal Server Error',
  InternalServerErrorSubtitle: 'Something went wrong on our end',
  BackToProjects: 'Back to Homepage',
  BackToPreviousPage: 'Back to previous page',
}
